import React from 'react';
import classNames from 'classnames';

import type { IconProps, IconType } from './types';
import { ICON_BY_TYPE } from './constants';

import './Icon.scss';

const Icon = ({ icon, size = 'md', className, ...props }: IconProps) => {
  const SelectedIcon = ICON_BY_TYPE[icon as IconType]!;

  return (
    <SelectedIcon
      className={classNames(
        'custom-icon',
        `custom-icon--size-${size}`,
        className
      )}
      {...props}
    />
  );
};

export default Icon;
